
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_47872_37044)"}},[_c('path',{attrs:{"d":"M5.052 1.267a.795.795 0 01.06 1.126L2.72 5.049a.784.784 0 01-.571.262.815.815 0 01-.584-.232L.234 3.75a.804.804 0 010-1.13.794.794 0 011.126 0l.733.735 1.83-2.032a.795.795 0 011.126-.06l.003.003zm0 5.313a.795.795 0 01.06 1.125L2.72 10.362a.784.784 0 01-.571.262.815.815 0 01-.584-.233L.234 9.063A.797.797 0 011.36 7.937l.733.735 1.83-2.033a.795.795 0 011.126-.06h.003zm2.387-3.394c0-.587.475-1.062 1.063-1.062h7.437a1.061 1.061 0 110 2.125H8.502a1.061 1.061 0 01-1.063-1.063zm0 5.313c0-.588.475-1.063 1.063-1.063h7.437a1.061 1.061 0 110 2.125H8.502A1.061 1.061 0 017.439 8.5zM5.314 13.81c0-.587.475-1.062 1.063-1.062h9.562a1.061 1.061 0 110 2.125H6.377a1.061 1.061 0 01-1.063-1.063zm-3.719-1.593a1.594 1.594 0 110 3.187 1.594 1.594 0 010-3.187z","fill":"#313131"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_47872_37044"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h17v17H0z"}})])])])
          )
        }
      }
    